export function validate_boolan(data) {
    
    if(typeof data === "boolean") return true; 

    return "txt159";

};
